import { Controller } from "@hotwired/stimulus"

// Handles the reservation status form interactions
export default class extends Controller {
  connect() {
    // Ensure the form has proper validation
    this.element.addEventListener('submit', this.validateForm.bind(this))
  }
  
  validateForm(event) {
    const notesField = this.element.querySelector('input[name="change_notes"]')
    
    if (!notesField.value || notesField.value.trim() === '') {
      event.preventDefault()
      alert('Please provide a reason for changing the reservation status.')
      notesField.focus()
      return false
    }
    
    return true
  }
}
